"use client";

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";
import { applyFontSize, FONT_SIZES, readAndMigrateClientFontSize, type FontSize } from "@/lib/font-size";
import { BarPrefix, ResponsiveContainer, ResponsiveContainerBlock } from "@/components/frontend/layout/header/responsive-container";
import type { FontSizeSwitch as FontSizeSwitchT } from "@/payload-types";

const sizeClasses: Record<FontSize, string> = {
	small: "text-[0.875em]",
	default: "text-[1em]",
	large: "text-[1.25em]",
};

type FontSizeSwitchProps = ResponsiveContainerBlock &
	FontSizeSwitchT & {
		barPrefix: BarPrefix;
	};

export const FontSizeSwitch: React.FC<FontSizeSwitchProps> = ({ barPrefix, ...props }) => {
	const t = useTranslations("fontSize");
	const [size, setSize] = useState<FontSize>("default");

	useEffect(() => {
		setSize(readAndMigrateClientFontSize());
	}, []);

	return (
		<ResponsiveContainer block={props} barPrefix={barPrefix}>
			<nav aria-label={t("label")} className="flex items-end gap-1 leading-none" style={{ fontSize: 16 }}>
				{FONT_SIZES.map((value) => (
					<button
						key={value}
						type="button"
						aria-label={t(value)}
						aria-pressed={size === value}
						onClick={() => {
							setSize(value);
							applyFontSize(value);
						}}
						className={cn(
							"leading-none cursor-pointer transition-opacity",
							sizeClasses[value],
							size === value ? "font-bold opacity-100" : "font-normal opacity-50 hover:opacity-100",
						)}
					>
						A
					</button>
				))}
			</nav>
		</ResponsiveContainer>
	);
};
